<script setup>
import menu from '@/menu';
import { computed, ref } from 'vue';
import cardType from './cardType.vue'
import { Icon } from '@iconify/vue';
import BookType from './bookType.vue';
const listType = ref('card')
const filterType = ref('')
const menuItems = computed(() =>
  filterType.value
    ? menu.value.filter(item => item.kategori === filterType.value)
    : menu.value
);

</script>

<template>
  <div class="flex flex-col items-center w-full ">
    <div class="flex  p-1 bg-white/20 text-gray-400 mb-2  relative rounded-full gap-2">
      <div :class="listType == 'card' ? '' : 'translate-x-12'"
        class="absolute h-10 w-10 bg-amber-400 text-white  duration-300 rounded-full overflow-hidden">
        <div :class="listType == 'card' ? '' : '-translate-x-10'"
          class="test flex w-20 text-black  p-[6px] duration-300 items-center h-full justify-between">
          <Icon icon="ep:menu" class="size-7 " />
          <Icon icon="material-symbols-light:menu-book" class="size-7" />
        </div>
      </div>
      <button @click="listType = 'card'"
        class="w-10 h-10 rounded-full  active:outline-none focus:outline-none active:ring-0 focus:ring-0 border-0 shadow-none  cursor-pointer justify-center font-medium  flex">
        <Icon icon="ep:menu" class="size-7 self-center" />
      </button>
      <button @click="listType = 'book'"
        class="w-10 h-10 rounded-full  active:outline-none focus:outline-none active:ring-0 focus:ring-0 border-0 shadow-none  cursor-pointer justify-center font-medium  flex">
        <Icon icon="material-symbols-light:menu-book" class="size-7 self-center" />
      </button>

    </div>
    <div class="flex gap-2">
      <button @click="filterType = ''" :class="filterType == '' ? 'bg-amber-400' : 'bg-gray-600 '" class="p-2 px-3  active:outline-none rounded-full focus:outline-none active:ring-0 focus:ring-0
               border-0 shadow-none cursor-pointer font-medium text-white duration-200">
        Semua
      </button>
      <button @click="filterType = 'makanan'"  :class="filterType == 'makanan' ? 'bg-amber-400' : 'bg-gray-600 '" class="p-2 px-3   active:outline-none rounded-full focus:outline-none active:ring-0 focus:ring-0
               border-0 shadow-none  cursor-pointer font-medium text-white duration-200">
        <Icon icon="mdi:food-ramen" class="size-8" />

      </button>
      <button @click="filterType = 'minuman'"  :class="filterType == 'minuman' ? 'bg-blue-400' : 'bg-gray-600 '" class="p-2 px-3   active:outline-none rounded-full focus:outline-none active:ring-0 focus:ring-0
               border-0 shadow-none  cursor-pointer font-medium text-white duration-200">
        <Icon icon="icon-park-solid:tea-drink" class="size-8" />


      </button>
      <button @click="filterType = 'dessert'"  :class="filterType == 'dessert' ? 'bg-white text-black' : 'bg-gray-600 text-white'" class="p-2 px-3   active:outline-none rounded-full focus:outline-none active:ring-0 focus:ring-0
               border-0 shadow-none cursor-pointer font-medium duration-200">
        <Icon icon="fluent:food-cake-12-filled" class="size-8" />

      </button>

    </div>
    <div class="w-full mt-20">
      <transition enter-active-class="animate__fadeIn animate__animated animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__faster" mode="out-in">
        <cardType v-if="listType == 'card'" :items="menuItems" />
        <BookType v-else-if="listType == 'book'" :items="menuItems" />
      </transition>

    </div>

  </div>


</template>